<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="calibre11" id="pgepubid00004">LIST OF CHAPTERS</h2>
<table cellpadding="2" cellspacing="0" class="calibre19" summary="toc">
<tbody class="calibre20"><tr class="calibre21"><td class="calibre22"><a class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0005">1.</a></td>
<td class="title">The Way to Butterfield</td>
</tr>
<tr class="calibre21"><td class="calibre22"><a class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0006">2.</a></td>
<td class="title">Dorothy Meets Button-bright</td>
</tr>
<tr class="calibre21"><td class="calibre22"><a class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0007">3.</a></td>
<td class="title">A Queer Village</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0008" title="Link target outside of Sample">4.</span></td>
<td class="title">King Dox</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0009" title="Link target outside of Sample">5.</span></td>
<td class="title">The Rainbow's Daughter</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0010" title="Link target outside of Sample">6.</span></td>
<td class="title">The City of Beasts</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0011" title="Link target outside of Sample">7.</span></td>
<td class="title">The Shaggy Man's Transformation</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0012" title="Link target outside of Sample">8.</span></td>
<td class="title">The Musicker</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0013" title="Link target outside of Sample">9.</span></td>
<td class="title">Facing the Scoodlers</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0014" title="Link target outside of Sample">10.</span></td>
<td class="title">Escaping the Soup-kettle</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0015" title="Link target outside of Sample">11.</span></td>
<td class="title">Johnny Dooit Does It</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0016" title="Link target outside of Sample">12.</span></td>
<td class="title">The Deadly Desert Crossed</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0017" title="Link target outside of Sample">13.</span></td>
<td class="title">The Truth Pond</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0018" title="Link target outside of Sample">14.</span></td>
<td class="title">Tik-Tok and Billina</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0019" title="Link target outside of Sample">15.</span></td>
<td class="title">The Emperor's Tin Castle</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0020" title="Link target outside of Sample">16.</span></td>
<td class="title">Visiting the Pumpkin-Field</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0021" title="Link target outside of Sample">17.</span></td>
<td class="title">The Royal Chariot Arrives</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0022" title="Link target outside of Sample">18.</span></td>
<td class="title">The Emerald City</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0023" title="Link target outside of Sample">19.</span></td>
<td class="title">The Shaggy Man's Welcome</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0024" title="Link target outside of Sample">20.</span></td>
<td class="title">Princess Ozma of Oz</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0025" title="Link target outside of Sample">21.</span></td>
<td class="title">Dorothy Receives the Guests</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0026" title="Link target outside of Sample">22.</span></td>
<td class="title">Important Arrivals</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0027" title="Link target outside of Sample">23.</span></td>
<td class="title">The Grand Banquet</td>
</tr>
<tr class="calibre21"><td class="calibre22"><span class="pcalibre pcalibre1 pcalibre2 calibre1" href="#/Text/Section0028" title="Link target outside of Sample">24.</span></td>
<td class="title">The Birthday Celebration</td>
</tr>
</tbody>
</table>
</div>
<p class="img"><img alt="image not available" class="calibre13" id="id-759205376910295977" src="Images/img0007.png"/></p>
<p class="calibre16"><a class="pcalibre pcalibre1 pcalibre2 calibre1" id="CHAP_1"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?06185bf9